module.exports = __webpack_public_path__ + "static/media/SWSCRC1-19.69145838.mp3";